import "@/App.css";
import { BrowserRouter, Routes, Route, Outlet, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { Toaster } from "sonner";
import { HelmetProvider } from "react-helmet-async";
import { SettingsProvider } from "./context/SettingsContext";
import useSmoothScroll from "./hooks/useSmoothScroll";
import Navbar from "./components/site/Navbar";
import StickyMobileBar from "./components/site/StickyMobileBar";
import Home from "./pages/Home";
import TripDetail from "./pages/TripDetail";
import AdminLogin from "./pages/admin/AdminLogin";
import AdminDashboard from "./pages/admin/AdminDashboard";
import { HyderabadToSrisailam, TourPackages, Sightseeing, CabService, Contact } from "./pages/SeoPages";

function ScrollToTop() {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) {
      const el = document.getElementById(hash.slice(1));
      if (el) { el.scrollIntoView({ behavior: "smooth" }); return; }
    }
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [pathname, hash]);
  return null;
}

function PublicLayout() {
  useSmoothScroll();
  return (
    <>
      <Navbar />
      <ScrollToTop />
      <Outlet />
      <StickyMobileBar />
    </>
  );
}

function App() {
  return (
    <HelmetProvider>
      <div className="App">
        <div className="grain" />
        <Toaster position="top-center" richColors />
        <BrowserRouter>
          <SettingsProvider>
            <Routes>
              <Route element={<PublicLayout />}>
                <Route path="/" element={<Home />} />
                <Route path="/trips/:slug" element={<TripDetail />} />
                <Route path="/hyderabad-to-srisailam" element={<HyderabadToSrisailam />} />
                <Route path="/srisailam-tour-packages" element={<TourPackages />} />
                <Route path="/srisailam-sightseeing" element={<Sightseeing />} />
                <Route path="/srisailam-cab-service" element={<CabService />} />
                <Route path="/contact" element={<Contact />} />
              </Route>
              <Route path="/admin/login" element={<AdminLogin />} />
              <Route path="/admin" element={<AdminDashboard />} />
            </Routes>
          </SettingsProvider>
        </BrowserRouter>
      </div>
    </HelmetProvider>
  );
}

export default App;
